import React, { useCallback, useMemo } from "react";
import { Drawer } from "@mui/material";
import EmbeddedCheckoutForm from ".";
import CheckoutStepper from "@/shared/components/CheckoutStepper";
import PaymentInfoMsg from "../PaymentInfoMsg";
import { STRIPE_MAX_AMOUNT } from "@/config/appConfig";
import NotSupportedAmountMsg from "../NotSupportedAmountMsg";
import { logger } from "@/helpers/loggerHelper";

type CheckoutPopupData = {
  amount?: number | string;
  return_url?: string;
  [key: string]: unknown;
};

type ClientSecretResponse = {
  data?: {
    result?: {
      client_secret?: string;
    };
  };
};

type ConfirmStripeEmbedCheckoutPopupProps = {
  api?: (_data: CheckoutPopupData) => Promise<ClientSecretResponse>;
  data?: CheckoutPopupData;
  locSubscription?: boolean;
  makePayment?: boolean;
  onClose?: () => void;
  return_uri?: string;
};

function ConfirmStripeEmbedCheckoutPopup({
  makePayment = false,
  data = {},
  onClose,
  return_uri = `/subscription-return`,
  api,
  locSubscription,
}: ConfirmStripeEmbedCheckoutPopupProps) {
  const handleError = useCallback(
    (err: unknown) => {
      logger.error("EmbeddedCheckoutForm error", err);
      if (onClose && typeof onClose === "function") {
        onClose();
      }
    },
    [onClose]
  );

  const isMoreThanStripeMaxAmount = useMemo(() => {
    const { amount } = data || {};
    const numericAmount = Number(amount);

    return amount && !isNaN(numericAmount) && numericAmount > STRIPE_MAX_AMOUNT
      ? amount
      : false;
  }, [data]);

  if (isMoreThanStripeMaxAmount)
    return (
      <NotSupportedAmountMsg
        makePayment={makePayment}
        onOkNotSupportedAmount={onClose}
      />
    );

  return (
    <>
      {/* <RpPreventNavigation prevent={makePayment ? true : false} /> */}
      <Drawer
        open={makePayment}
        anchor="bottom"
        className="payment-drawer"
        transitionDuration={0}
        disableEnforceFocus
      >
        {/* <div className="text-right cursor-p">
          <Cancel className="mr-2" onClick={handleClose} color="action" />
        </div> */}
        <div>
          {locSubscription && (
            <div className="mt-4">
              <CheckoutStepper activeStep={2} />
            </div>
          )}
          <div className="d-flex justify-content-center align-items-center mt-5">
            <EmbeddedCheckoutForm
              data={{
                ...data,
                return_url: `${window.location.origin}${return_uri}`,
              }}
              onError={handleError}
              api={api}
            />
          </div>
        </div>
      </Drawer>
      <PaymentInfoMsg makePayment={makePayment} />
    </>
  );
}

export default ConfirmStripeEmbedCheckoutPopup;
